export type TInferredContactType = 'Prospect' | 'Undetermined' | 'Non-Prospect' | '';

export interface IContactDetails {
  siteId: number;
  firstName: string;
  lastName: string;
  providePhone: string;
  callerId: string;
  email: string;
  inferredContactType: TInferredContactType;
  inferredContactSubtype: string;
  inferredContactTypeJustification: string;
  inferredContactSubtypeJustification: string;
  qualifiedProspect: boolean;
  qualifiedProspectJustification: string;
}

export class ContactDetailsModel implements IContactDetails {
  siteId: number = 0;
  firstName: string = '';
  lastName: string = '';
  providePhone: string = '';
  callerId: string = '';
  email: string = '';
  inferredContactType: TInferredContactType = '';
  inferredContactSubtype: string = '';
  inferredContactTypeJustification: string = '';
  inferredContactSubtypeJustification: string = '';
  qualifiedProspect: boolean = false;
  qualifiedProspectJustification: string = '';

  constructor(data: IContactDetails = {} as IContactDetails) {
    this.siteId = data?.siteId ?? this.siteId;
    this.firstName = data?.firstName ?? this.firstName;
    this.lastName = data?.lastName ?? this.lastName;
    this.providePhone = data?.providePhone ?? this.providePhone;
    this.callerId = data?.callerId ?? this.callerId;
    this.email = data?.email ?? this.email;
    this.inferredContactType = data?.inferredContactType ?? this.inferredContactType;
    this.inferredContactSubtype = data?.inferredContactSubtype ?? this.inferredContactSubtype;
    this.inferredContactTypeJustification =
      data.inferredContactTypeJustification ?? this.inferredContactTypeJustification;
    this.inferredContactSubtypeJustification =
      data.inferredContactSubtypeJustification ?? this.inferredContactSubtypeJustification;
    this.qualifiedProspect = data.qualifiedProspect ?? this.qualifiedProspect;
    this.qualifiedProspectJustification = data.qualifiedProspectJustification ?? this.qualifiedProspectJustification;
  }
}
